var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showvitalspopup
        ? _c(
            "div",
            [
              _vm._v(
                "\n        " + _vm._s(_vm.renderVitalsForm) + "\n        "
              ),
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-container",
                        staticStyle: { padding: "0" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "modal-header popup-header-colored popup-header-blue",
                          },
                          [
                            _c("div", { staticClass: "popup-title" }, [
                              _c(
                                "svg",
                                {
                                  staticStyle: {
                                    width: "18px",
                                    height: "18px",
                                  },
                                  attrs: {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("polyline", {
                                    attrs: {
                                      points: "22 12 18 12 15 21 9 3 6 12 2 12",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                                Vitals\n                            "
                              ),
                            ]),
                            _c(
                              "button",
                              {
                                staticClass: "close popup-close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.$emit("cancelAction")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                ×\n                            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "modal-body popup-body" },
                          [
                            _vm._t("body", function () {
                              return [
                                _vm.loaderspinner
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "appointmentlist-spinner",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "processing_popup full-spinner",
                                            staticStyle: {
                                              visibility: "visible",
                                              top: "-68px",
                                              height: "100%",
                                              "z-index": "9999999999",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "spinner cover-spin",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "bounce1",
                                                }),
                                                _c("div", {
                                                  staticClass: "bounce2",
                                                }),
                                                _c("div", {
                                                  staticClass: "bounce3",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", {}, [
                                  _c("div", {}, [
                                    _c(
                                      "div",
                                      { staticClass: "report-vital-section" },
                                      [
                                        _c(
                                          "form",
                                          {
                                            attrs: {
                                              id: "div-renderform2OuterVitals",
                                            },
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _vm.Vitals_Inpatient_UpdatedDate &&
                                            _vm.Vitals_Inpatient_UpdatedBy
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "update_info",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          id: "vitaluppdate",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Updated by " +
                                                            _vm._s(
                                                              _vm.Vitals_Inpatient_UpdatedBy
                                                            ) +
                                                            " on " +
                                                            _vm._s(
                                                              _vm.Vitals_Inpatient_UpdatedDate
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 form-group field-min-blood-pressure",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "vital-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Blood Pressure — Systolic (mmHg)"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form[
                                                            "min-blood-pressure"
                                                          ],
                                                        expression:
                                                          "form['min-blood-pressure']",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      id: "min-blood-pressure",
                                                      name: "min-blood-pressure",
                                                      min: "50",
                                                      placeholder: "Systolic",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form[
                                                          "min-blood-pressure"
                                                        ],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form,
                                                          "min-blood-pressure",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 form-group field-max-blood-pressure",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "vital-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Blood Pressure — Diastolic (mmHg)"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form[
                                                            "max-blood-pressure"
                                                          ],
                                                        expression:
                                                          "form['max-blood-pressure']",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      id: "max-blood-pressure",
                                                      name: "max-blood-pressure",
                                                      min: "25",
                                                      placeholder: "Diastolic",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form[
                                                          "max-blood-pressure"
                                                        ],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form,
                                                          "max-blood-pressure",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 form-group field-heart-rate",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "vital-label",
                                                      attrs: {
                                                        for: "heart-rate",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Heart Rate / Pulse (bpm)"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form[
                                                            "heart-rate"
                                                          ],
                                                        expression:
                                                          "form['heart-rate']",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      id: "heart-rate",
                                                      name: "heart-rate",
                                                      min: "10",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form["heart-rate"],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form,
                                                          "heart-rate",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 form-group field-02-sat",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "vital-label",
                                                      attrs: { for: "02-sat" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "O₂ Sat / SpO₂ (%)"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form["02-sat"],
                                                        expression:
                                                          "form['02-sat']",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      id: "02-sat",
                                                      name: "02-sat",
                                                      min: "0",
                                                    },
                                                    domProps: {
                                                      value: _vm.form["02-sat"],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form,
                                                          "02-sat",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-4" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-8 form-group field-temperature",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "vital-label",
                                                              attrs: {
                                                                for: "temperature",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Temperature"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.form[
                                                                    "temperature"
                                                                  ],
                                                                expression:
                                                                  "form['temperature']",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            attrs: {
                                                              type: "number",
                                                              id: "temperature",
                                                              name: "temperature",
                                                              min: "0",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.form[
                                                                  "temperature"
                                                                ],
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "temperature",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 form-group field-temperature-unit",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "vital-label",
                                                              attrs: {
                                                                for: "temperature-unit",
                                                              },
                                                            },
                                                            [_vm._v("Unit")]
                                                          ),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.form[
                                                                      "temperature-unit"
                                                                    ],
                                                                  expression:
                                                                    "form['temperature-unit']",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                id: "temperature-unit",
                                                                name: "temperature-unit",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.$set(
                                                                      _vm.form,
                                                                      "temperature-unit",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "F",
                                                                  },
                                                                },
                                                                [_vm._v("F")]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "C",
                                                                  },
                                                                },
                                                                [_vm._v("C")]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 form-group field-respiratory-rate",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "vital-label",
                                                      attrs: {
                                                        for: "respiratory-rate",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Respiratory Rate (/min)"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form[
                                                            "respiratory-rate"
                                                          ],
                                                        expression:
                                                          "form['respiratory-rate']",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      id: "respiratory-rate",
                                                      name: "respiratory-rate",
                                                      min: "10",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form[
                                                          "respiratory-rate"
                                                        ],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form,
                                                          "respiratory-rate",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "popup-bg" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "popup-bg-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Anthropometry & BMI"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-4",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-8 form-group field-height-value",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "vital-label",
                                                                    attrs: {
                                                                      for: "height-value",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Height"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .form[
                                                                          "height-value"
                                                                        ],
                                                                      expression:
                                                                        "form['height-value']",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    type: "number",
                                                                    id: "height-value",
                                                                    name: "height-value",
                                                                    min: "0",
                                                                    step: "0.1",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form[
                                                                        "height-value"
                                                                      ],
                                                                  },
                                                                  on: {
                                                                    input: [
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm.form,
                                                                          "height-value",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                      _vm.calculateBMI,
                                                                    ],
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-4 form-group field-height-unit-selected",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "vital-label",
                                                                    attrs: {
                                                                      for: "height-unit-selected",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Unit"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "select",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .form[
                                                                              "height-unit-selected"
                                                                            ],
                                                                          expression:
                                                                            "form['height-unit-selected']",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      id: "height-unit-selected",
                                                                      name: "height-unit-selected",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$selectedVal =
                                                                            Array.prototype.filter
                                                                              .call(
                                                                                $event
                                                                                  .target
                                                                                  .options,
                                                                                function (
                                                                                  o
                                                                                ) {
                                                                                  return o.selected
                                                                                }
                                                                              )
                                                                              .map(
                                                                                function (
                                                                                  o
                                                                                ) {
                                                                                  var val =
                                                                                    "_value" in
                                                                                    o
                                                                                      ? o._value
                                                                                      : o.value
                                                                                  return val
                                                                                }
                                                                              )
                                                                          _vm.$set(
                                                                            _vm.form,
                                                                            "height-unit-selected",
                                                                            $event
                                                                              .target
                                                                              .multiple
                                                                              ? $$selectedVal
                                                                              : $$selectedVal[0]
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "ft",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "ft"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "cm",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "cm"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-4",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-8 form-group field-weight-value",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "vital-label",
                                                                    attrs: {
                                                                      for: "weight-value",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Weight"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .form[
                                                                          "weight-value"
                                                                        ],
                                                                      expression:
                                                                        "form['weight-value']",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    type: "number",
                                                                    id: "weight-value",
                                                                    name: "weight-value",
                                                                    min: "0",
                                                                    step: "0.1",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form[
                                                                        "weight-value"
                                                                      ],
                                                                  },
                                                                  on: {
                                                                    input: [
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm.form,
                                                                          "weight-value",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                      _vm.calculateBMI,
                                                                    ],
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-4 form-group field-weight-unit-selected",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "vital-label",
                                                                    attrs: {
                                                                      for: "weight-unit-selected",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Unit"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "select",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .form[
                                                                              "weight-unit-selected"
                                                                            ],
                                                                          expression:
                                                                            "form['weight-unit-selected']",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      id: "weight-unit-selected",
                                                                      name: "weight-unit-selected",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$selectedVal =
                                                                            Array.prototype.filter
                                                                              .call(
                                                                                $event
                                                                                  .target
                                                                                  .options,
                                                                                function (
                                                                                  o
                                                                                ) {
                                                                                  return o.selected
                                                                                }
                                                                              )
                                                                              .map(
                                                                                function (
                                                                                  o
                                                                                ) {
                                                                                  var val =
                                                                                    "_value" in
                                                                                    o
                                                                                      ? o._value
                                                                                      : o.value
                                                                                  return val
                                                                                }
                                                                              )
                                                                          _vm.$set(
                                                                            _vm.form,
                                                                            "weight-unit-selected",
                                                                            $event
                                                                              .target
                                                                              .multiple
                                                                              ? $$selectedVal
                                                                              : $$selectedVal[0]
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "kg",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "kg"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "lb",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "lb"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-4 form-group field-calculated-bmi-value",
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "vital-label",
                                                            attrs: {
                                                              for: "calculated-bmi-value",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "BMI Calculated"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form[
                                                                  "calculated-bmi-value"
                                                                ],
                                                              expression:
                                                                "form['calculated-bmi-value']",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "number",
                                                            id: "calculated-bmi-value",
                                                            name: "calculated-bmi-value",
                                                            min: "0",
                                                            step: "0.01",
                                                            readonly: "",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.form[
                                                                "calculated-bmi-value"
                                                              ],
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.form,
                                                                "calculated-bmi-value",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "row",
                                                    attrs: { hidden: "" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-5 form-group field-calculate-bmi-button",
                                                        staticStyle: {
                                                          "margin-bottom": "0",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "md-button md-raised md-primary md-theme-default btn btn-primary",
                                                            attrs: {
                                                              type: "button",
                                                              id: "calculate-bmi-button",
                                                              name: "calculate-bmi-button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.calculateBMI.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "Calculate BMI"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 form-group field-textarea-1543496414210",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "vital-label",
                                                      attrs: {
                                                        for: "textarea-1543496414210",
                                                      },
                                                    },
                                                    [_vm._v("Doctor's Summary")]
                                                  ),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form[
                                                            "textarea-1543496414210"
                                                          ],
                                                        expression:
                                                          "form['textarea-1543496414210']",
                                                      },
                                                    ],
                                                    ref: "doctorSummary",
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      id: "textarea-1543496414210",
                                                      name: "textarea-1543496414210",
                                                      rows: "3",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form[
                                                          "textarea-1543496414210"
                                                        ],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form,
                                                          "textarea-1543496414210",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "row right",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12",
                                                        },
                                                        [
                                                          _vm.Gender !=
                                                            "male" ||
                                                          _vm.Gender != "Male"
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-md-6 formbuilder-radio-group form-group field-radio-group-1546595623086",
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "vital-label",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-right":
                                                                            "8px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Is pregnant?"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "radio-inline",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .form[
                                                                                    "radio-group-1546595623086"
                                                                                  ],
                                                                                expression:
                                                                                  "form['radio-group-1546595623086']",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              type: "radio",
                                                                              name: "radio-group-1546595623086",
                                                                              id: "radio-group-1546595623086-0",
                                                                              value:
                                                                                "Yes",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .form[
                                                                                    "radio-group-1546595623086"
                                                                                  ],
                                                                                  "Yes"
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm.form,
                                                                                  "radio-group-1546595623086",
                                                                                  "Yes"
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " Yes\n                                                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "radio-inline",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .form[
                                                                                    "radio-group-1546595623086"
                                                                                  ],
                                                                                expression:
                                                                                  "form['radio-group-1546595623086']",
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              type: "radio",
                                                                              name: "radio-group-1546595623086",
                                                                              id: "radio-group-1546595623086-1",
                                                                              value:
                                                                                "No",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              checked:
                                                                                _vm._q(
                                                                                  _vm
                                                                                    .form[
                                                                                    "radio-group-1546595623086"
                                                                                  ],
                                                                                  "No"
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.$set(
                                                                                  _vm.form,
                                                                                  "radio-group-1546595623086",
                                                                                  "No"
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " No\n                                                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pull-right",
                                                              staticStyle: {
                                                                display: "flex",
                                                                "align-items":
                                                                  "center",
                                                                gap: "12px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "primary-btn ripple",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.saveVitals.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("Save")]
                                                              ),
                                                              _vm.isVitalSaved
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        href: "javascript:void(0);",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.viewVitalspopup,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              src: require("@/static/images/print-icon.png"),
                                                                              alt: "Print",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c("vitalsprintpopup", {
        ref: "vitalsPopUpRefModal",
        attrs: { vitalsobj: _vm.vitalspopObj },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }